import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectWdCurrentLayoutConfig, selectToolbarTheme } from 'app/store/core/settingsSlice';
import { NotificationPanelToggleButton } from '@modules/notifications/components';
import { NotificationBar } from 'app/components';
import { selectWdNavbar } from 'app/store/core/navbarSlice';
import { openNotificationPanel } from '@modules/notifications/store';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
// import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
// import NavigationShortcuts from '../../shared-components/NavigationShortcuts';
import NavigationSearch from '../../shared-components/NavigationSearch';
import NavbarToggleButton from '../../shared-components/NavbarToggleButton';
import UserMenu from '../../shared-components/UserMenu';

function ToolbarLayout1(props) {
  const Dispatch = useDispatch();
  const config = useSelector(selectWdCurrentLayoutConfig);
  const navbar = useSelector(selectWdNavbar);
  const toolbarTheme = useSelector(selectToolbarTheme);
  const { notifications } = useSelector((state) => state.notifications);
  const profile = useSelector((state) => state.profile);
  const { api } = useSelector((state) => state.config.config);
  const { host } = api;

  const handleShowNotificationPanel = () => {
    Dispatch(openNotificationPanel());
  };

  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="Wd-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? toolbarTheme.palette.background.paper
              : toolbarTheme.palette.background.default,
        }}
        position="static"
      >
        <Toolbar className="p-0 min-h-48 md:min-h-64">
          <div className="flex flex-1 sm:flex-none px-16">
            {config.navbar.display && config.navbar.position === 'left' && (
              <>
                <Hidden lgDown>
                  {(config.navbar.style === 'style-3' ||
                    config.navbar.style === 'style-3-dense') && (
                    <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
                  )}

                  {config.navbar.style === 'style-1' && !navbar.open && (
                    <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
                  )}
                </Hidden>

                <Hidden lgUp>
                  <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
                </Hidden>
              </>
            )}
          </div>
          <div className="hidden sm:flex flex-1 overflow-hidden px-8">
            <NotificationBar />
          </div>
          <div className="flex items-center px-8 h-full overflow-x-auto">
            {/* <LanguageSwitcher /> */}

            <AdjustFontSize />

            <FullScreenToggle />

            <NavigationSearch />

            <NotificationPanelToggleButton
              isEmpty={notifications.length === 0}
              onClick={handleShowNotificationPanel}
            >
              {notifications.length}
            </NotificationPanelToggleButton>

            <UserMenu user={profile} baseUrl={host} authenticated={profile !== null}>
              <UserMenu.Item
                icon="heroicons-outline:lock-closed"
                title="Autenticar"
                role="button"
                to="/sign-in"
              />
              <UserMenu.Item
                icon="heroicons-outline:user-add"
                title="Registrarse"
                role="button"
                to="/sign-up"
              />
              <UserMenu.Item
                icon="heroicons-outline:user-circle"
                title="Mi perfil"
                role="button"
                to="/myself"
                needsAuth
              />
              <UserMenu.Item
                icon="heroicons-outline:logout"
                title="Salir"
                role="button"
                to="/sign-out"
                needsAuth
              />
            </UserMenu>
          </div>

          {config.navbar.display && config.navbar.position === 'right' && (
            <>
              <Hidden lgDown>
                {!navbar.open && <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />}
              </Hidden>

              <Hidden lgUp>
                <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
              </Hidden>
            </>
          )}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default memo(ToolbarLayout1);
